module.exports = __webpack_public_path__ + "img/R-8.fa0593d6.png";